jQuery('.util.edit').click(function(){
	
	jQuery( this ).parent().addClass('edit-mode');
	
});

jQuery('.util.close').click(function(){
	
	jQuery( this ).parent().removeClass('edit-mode');
	
});

jQuery('.button.save-changes').click(function(){
	
	var id = jQuery('.consultant-banner').data('consultant');
	var keys = [];
	
	jQuery( this ).parent().find('input').each(function(){
		
		keys.push({
			
			key: jQuery(this).attr('id'),
			value: jQuery(this).val(),
			type: jQuery(this).data('type'),
			row: jQuery(this).data('row')
			
		});
		
	});
	
	jQuery( this ).parent().find('select').each(function(){
		
		keys.push({
			
			key: jQuery(this).attr('id'),
			value: jQuery(this).val(),
			type: jQuery(this).data('type'),
			row: jQuery(this).data('row')
			
		});
		
	});
	
	jQuery( this ).parent().find('textarea').each(function(){
		
		keys.push({
			
			key: jQuery(this).attr('id'),
			value: jQuery(this).val(),
			type: jQuery(this).data('type'),
			row: jQuery(this).data('row')
			
		});
		
	});
	
	update_account_consultant(id, keys);
		
});

jQuery('button.add-more').click(function(){
	
	var parent = jQuery( this ).parent();
	
	var last = parent.find('.edit-form:last');

	var last_row = last.data('row');
	
	var new_row = parseInt(last_row) + 1;

	var clone = last.clone().attr('data-row', new_row);//removeAttr('value');
	
		clone.insertAfter( last );
	
		clone.find("input[type='text'], textarea, select").removeAttr('value').attr({'data-row': new_row, 'value': ''}).val('');
	
		clone.find(".grid-x:first").find("input[type='text'], textarea, select").attr({'data-type': 'new'});
	
	///	clone.	
	
	//var new_elem = '.edit-form[data-row="' + new_row + '"]';
	
	//clone.insertAfter('.edit-form:last').attr('data-row', new_row).find("input[type='text'], textarea, select").val('').attr({'data-row': new_row, 'data-type': 'new'});
	
	
	
	
});

jQuery('#cb-comment-submit').click(function(){
	
	if( jQuery('#cb-comment').val() != '' ){
		cb_comment_form();
	}
	
	else {
		alert('Please enter a comment');
	}
	
});
